import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Android15Alert } from "./components/Android15Alert";
import { Features } from "./components/Features";
import { HowItWorks } from "./components/HowItWorks";
import { WhyChoose } from "./components/WhyChoose";
import { Pricing } from "./components/Pricing";
import { FAQ } from "./components/FAQ";
import { Disclaimer } from "./components/Disclaimer";
import { Footer } from "./components/Footer";
import { TermsOfService } from "./pages/TermsOfService";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";

const HomePage = () => (
  <>
    <Hero />
    <Android15Alert />
    <Features />
    <HowItWorks />
    <WhyChoose />
    <Pricing />
    <FAQ />
    <Disclaimer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/syarat-ketentuan" element={<TermsOfService />} />
          <Route path="/kebijakan-privasi" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
